import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'decimalToComma' })
export class DecimalToCommaPipe implements PipeTransform {
	transform(value: string, maxDecimals?: number, minDecimals: number = 2) {
		let ret = value != null ? value.toString().replace('.', ',') : null;
		if (ret) {
			const decArr = ret.split(',');
			if (decArr.length > 1) {
				const limit = typeof maxDecimals === 'number' ? maxDecimals : 2;
				const dec = decArr[1].length;
				if (dec > limit) {
					ret = ret.substr(0, ret.indexOf(',') + 1 + limit);
				} else if (dec < minDecimals) {
					ret = ret + '0'.repeat(minDecimals - dec);
				}
			}
		}
		return ret;
	}
}
